import { render, staticRenderFns } from "./PrkBasicInformation.vue?vue&type=template&id=0180a7eb&scoped=true&"
import script from "./PrkBasicInformation.vue?vue&type=script&lang=js&"
export * from "./PrkBasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./PrkBasicInformation.vue?vue&type=style&index=0&id=0180a7eb&scoped=true&lang=scss&"
import style1 from "./PrkBasicInformation.vue?vue&type=style&index=1&id=0180a7eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180a7eb",
  null
  
)

export default component.exports